export default "__VITE_ASSET__c7046c78__"